import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  useDeleteExercise,
  useGetExerciseById,
} from '../../../services/redux/api/exercisesAPI';
import { useGetLanguages } from '../../../services/redux/api/translationsAPI';
import { Paths } from '../../../shared/paths';
import { getExerciseOptionUnitBracketSuffix } from '../../../utils/exercise-option-display';

interface UseExercisePageOptions {
  onBack?: () => void;
  onEditClick?: (id: string) => void;
}

export function useExercisePage(id: string, options?: UseExercisePageOptions) {
  const { data: exercise, error } = useGetExerciseById(id);
  const [deleteExercise, { isSuccess: isDeleteSuccess }] = useDeleteExercise();
  const [showDeleteConfirmation, setShowDeleteConfirmation] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const { data: languages } = useGetLanguages();

  useEffect(() => {
    if (isDeleteSuccess) {
      options?.onBack ? options.onBack() : navigate(-1);
    }
  }, [isDeleteSuccess, options?.onBack]);

  function handleEditClick(exerciseId: string) {
    if (options?.onEditClick) {
      options.onEditClick(exerciseId);
    } else {
      navigate(Paths.moderatorDashboard.exerciseEdit(exerciseId));
    }
  }

  function onDelete() {
    deleteExercise(id)
      .unwrap()
      .then(() => {
        setShowDeleteConfirmation(false);
      })
      .catch((e) => console.log(e));
  }

  function getOptionsLabel() {
    if (!exercise?.options?.length) return '';
    return exercise.options
      .map(
        (o) =>
          `${o.name || o.nameKey || ''}${getExerciseOptionUnitBracketSuffix(o)}`,
      )
      .join(', ');
  }

  return {
    exercise,
    languages,
    onEditClick: handleEditClick,
    onDelete,
    getOptionsLabel,
    showDeleteConfirmation,
    setShowDeleteConfirmation,
    exerciseLanguage: languages?.find((l) => l.id === exercise?.languageId)
      ?.title,
  };
}
